import ConfigData from "./config.json";
class Config {
  //static api = 'http://localhost:3001'
  //static api = 'http://192.61.99.40:8088/api/values';
  static async init() {
    if (process.env.NODE_ENV === "development") {
      Config.api = window.webApi.ConfigApi + "/MemberService";
      Config.Providerapi = window.webApi.ConfigApi + "/Provider";
      Config.Auth = window.webApi.ConfigApi + "/Authorization";
      Config.Providermgmt = window.webApi.ConfigApi + "/Providermgmt";
      Config.Ticket = window.webApi.ConfigApi + "/Ticket";
      Config.Enrolment = window.webApi.ConfigApi + "/Enrolment";
      Config.Report = window.webApi.ConfigApi + "/Reports";
      Config.CalypsoLite = window.webApi.CalypsoLite;
      Config.EnsureDataSolutions = window.webApi.EnsureDataSolutions;
      Config.SolisHealthPlan = window.webApi.SolisHealthPlan;
      Config.WelcomeMessage = window.webApi.WelcomeMessage;
      Config.OTC = window.webApi.OTC;
      Config.LaunchHraUrl = window.webApi.LaunchHraUrl;
      // Config.api = window.webApi.ConfigApi;
      // Config.Provider = window.webApi.ConfigProvider;
      // Config.api = "http://localhost:54808/api/MemberService";
      // Config.Providerapi = "http://localhost:3001/api/Provider";
      // Config.data = "http://localhost:3001";
    }
    // use url in production mode
    if (process.env.NODE_ENV === "production") {
      Config.api = window.webApi.ConfigApi + "/MemberService";
      Config.Providerapi = window.webApi.ConfigApi + "/Provider";
      Config.Auth = window.webApi.ConfigApi + "/Authorization";
      Config.Providermgmt = window.webApi.ConfigApi + "/Providermgmt";
      Config.Ticket = window.webApi.ConfigApi + "/Ticket";
      Config.Enrolment = window.webApi.ConfigApi + "/Enrolment";
      Config.Report = window.webApi.ConfigApi + "/Reports";
      // Config.api = 'http://192.61.99.40:8090/api/providermgmt';
      Config.CalypsoLite = window.webApi.CalypsoLite;
      Config.EnsureDataSolutions = window.webApi.EnsureDataSolutions;
      Config.SolisHealthPlan = window.webApi.SolisHealthPlan;
      Config.WelcomeMessage = window.webApi.WelcomeMessage;
      Config.OTC = window.webApi.OTC;
      Config.LaunchHraUrl = window.webApi.LaunchHraUrl;
    }
  }
  static tableColumns = ConfigData.columns;
  static membertable = ConfigData.MemberData;
  static eligibilitytable = ConfigData.EligibilityData;
  static userDetails = ConfigData.USerDetails.ListUser;
  static ipaUsers = ConfigData.IpaUsers;
}
export default Config;
